import React from 'react';
import PropTypes from 'prop-types';

const DateRangePicker = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  onApply,
  onClear,
  hasPendingChanges,
  minDate,
  maxDate,
}) => {
  const handleDateFromChange = (e) => {
    onDateFromChange(e.target.value);
  };

  const handleDateToChange = (e) => {
    onDateToChange(e.target.value);
  };

  const hasAnyDate = dateFrom || dateTo;

  return (
    <div className="d-flex align-items-center gap-2">
      <label htmlFor="date-from" className="form-label mb-0 fw-semibold text-nowrap">
        <i className="fa fa-calendar-o me-1" />
        From
      </label>
      <input
        id="date-from"
        type="date"
        className="form-control form-control-sm"
        value={dateFrom}
        onChange={handleDateFromChange}
        min={minDate}
        max={dateTo || maxDate}
        style={{ width: '150px' }}
      />
      <label htmlFor="date-to" className="form-label mb-0 fw-semibold text-nowrap">
        To
      </label>
      <input
        id="date-to"
        type="date"
        className="form-control form-control-sm"
        value={dateTo}
        onChange={handleDateToChange}
        min={dateFrom || minDate}
        max={maxDate}
        style={{ width: '150px' }}
      />
      <button
        type="button"
        className={`btn btn-sm ${hasPendingChanges ? 'btn-primary' : 'btn-outline-secondary'}`}
        onClick={onApply}
        disabled={!hasPendingChanges}
        title="Apply date filter"
      >
        <i className="fa fa-check me-1" />
        Apply
      </button>
      {hasAnyDate && (
        <button type="button" className="btn btn-sm btn-outline-danger" onClick={onClear} title="Clear date filter">
          <i className="fa fa-times" />
        </button>
      )}
    </div>
  );
};

DateRangePicker.propTypes = {
  dateFrom: PropTypes.string.isRequired,
  dateTo: PropTypes.string.isRequired,
  onDateFromChange: PropTypes.func.isRequired,
  onDateToChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  hasPendingChanges: PropTypes.bool.isRequired,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
};

export default DateRangePicker;
